module.exports = __webpack_public_path__ + "img/backyard-cross-angle.a7252395.webp";